<div class="Flexbox text-header-element-wrapper header-element max-width"
     *ngFor="let displayElement of (displayHeaderElements$ | async); trackBy:trackByFn"
     [ngClass]="{'max-width': displayElement.type != elementTypes.USER_PROFILE, 'indication-header': displayElement.id == elementTypes.INDICATION}">

  <ng-container [ngSwitch]="displayElement.type">
    <div class="Flexbox user-profile-element" *ngIf="displayElement.type == elementTypes.USER_PROFILE">
      <ng-container *ngIf="getValueForElement(displayElement.fields[0].values[0], displayElement.fields[0].values[0].keys['id']) | async as patientId">
        <gen-user-profile [userType]="displayElement.fields[0].values[0].keys['user-type']"
                          [id]="patientId"
                          [layout]="'SMALL_PIC_AND_NAME'"
                          [ngClass]="displayElement.fields[0].classes"></gen-user-profile>
      </ng-container>
      <gen-user-counter-warning [backUrlParams]="backUrlParams" [backUrl]="backUrl" [showDuplicatePatient]="showPatientWarning" class="align-center"
                                [name]="getValueForElement(displayElement.fields[0].values[1])| async"
                                [orderId]="orderId$ | async" [userId]="getValueForElement(displayElement.fields[0].values[2])| async"
                                [params]="{
                                    name: getValueForElement(displayElement.fields[0].values[1]) | async,
                                    userId: getValueForElement(displayElement.fields[0].values[2]) | async,
                                    from:'test-header'
                                }">
      </gen-user-counter-warning>
    </div>

    <div class="Flexbox header-element max-width"
         *ngIf="displayElement.type  == elementTypes.TEXT || displayElement.type == elementTypes.ONCOLOGY_REPORT">
      <ng-container class="Flexbox inherit-width" *ngFor="let field of displayElement.fields">
        <ng-container *ngIf="field.displayed$ | async ">
          <!--
                    <div *ngIf="displayElement.type  == elementTypes.ONCOLOGY_REPORT">
                      <a class="patient-details-caption"
                         target="_blank"
                         [attr.href]="getValueForElement(value)"><i class="icon__oncology_report"></i>Oncology
                        Summary</a>
                    </div>
          -->

          <div class="Flexbox inherit-width " *ngIf="displayElement.type === elementTypes.TEXT" [ngClass]="'AUTO_'+field.name">

            <ng-container *ngIf="field.label">
              <ng-container [ngSwitch]="field.label.type">
                <ng-container *ngSwitchCase="elementTypes.TEXT">
                  <span class="patient-details-header-label" translate>{{getValueForElement(field.label) | async}}{{field.labelValueSeparator}}</span>
                </ng-container>
              </ng-container>
            </ng-container>

            <div class="Flexbox" [ngClass]="field.classes" *ngFor="let value of field.values"
                 genTooltip
                 genEllipsis
                 [tooltipPosition]="'BOTTOM'"
                 [tooltipHtml]="value.displayedValue$ | async"
                 [tooltipShow]="field.showTooltip"
                 [reapply]="(field['reapplyTrigger$'] |async)"
                 (tooltipStateEmit)="field.showTooltip = $event" translate
            >
              <span *ngIf="field.name == 'mrn' && checkMultiMRN() | async" genTooltip genEllipsis
                    [tooltipHtml]="displayTooltipValues() | async "
                    [tooltipPosition]="'TOP'"
                    [appendToBody]="true"
                    [tooltipShow]="true"
              >
                <img style="height: 1.3rem;margin-left: 0.6rem;margin-bottom: 0.25rem" src="assets/ispm/icons/Info_Icon.png" />
              </span>
              <span class="patient-details-value header-element header-value"
                    [ngClass]="value.classes"
                    [innerHtml]="value.displayedValue$ | async | translate"
              ></span>
            </div>
          </div>

        </ng-container>
      </ng-container>
    </div>

    <!--
        <div class="Flexbox mdt-popup" *ngIf="displayElement.type == elementTypes.POPUP">
          <gen-button
            [type]="''"
            (click)="showMdt(displayElement.widgetpayoload.formId)"
            [text]="''"
            [iconClass]="'pointer icon__expand'">
          </gen-button>
        </div>
    -->

  </ng-container>
</div>
